import _typeof from '@babel/runtime/helpers/esm/typeof';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import CloseCircle from '@elliemae/ds-icons/CloseCircle';
import DSButton from '@elliemae/ds-button';
import DSTooltip from '@elliemae/ds-tooltip';
import InputAddonWrapper from './InputAddonWrapper.js';
import { showEllipsis } from './showEllipsis.js';
import '@babel/runtime/helpers/esm/toConsumableArray';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'input';
var Input = aggregatedClasses('input')(blockName, null, function (_ref) {
  var clearable = _ref.clearable,
      value = _ref.value;
  return {
    clearable: clearable,
    value: value
  };
});
var WrapperForTooltipInput = aggregatedClasses('div')(blockName, 'tooltip-ref');
var InputCustomWrapper = aggregatedClasses('div')(blockName, null, function (_ref2) {
  var clearable = _ref2.clearable,
      value = _ref2.value;
  return {
    clearable: clearable,
    value: value
  };
});
var ClearableButton = aggregatedClasses(DSButton)(blockName, 'clearable');

var getValidComponents = function getValidComponents(component) {
  return component;
};

var noop = function noop() {
  return null;
};

var InputImpl = /*#__PURE__*/function (_Component) {
  _inherits(InputImpl, _Component);

  var _super = _createSuper(InputImpl);

  function InputImpl(props) {
    var _this;

    _classCallCheck(this, InputImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "refTooltip", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          max = _this$props.max;
      var value = e.target.value;
      if (max && value > max) return;
      onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var _this$props2 = _this.props,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          min = _this$props2.min;
      var value = e.target.value;

      if (min && value < min && value !== '') {
        onChange({
          target: {
            value: min.toString()
          }
        });
      }

      onBlur(e);

      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var onFocus = _this.props.onFocus;
      onFocus(e);

      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      if (!_this.state.showTooltip) {
        _this.setState({
          showTooltip: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      if (_this.state.showTooltip) {
        _this.setState({
          showTooltip: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setWidth", function () {
      var client = _this.refTooltip.current.getBoundingClientRect();

      _this.setState({
        width: client.width
      });
    });

    _this.state = {
      width: -1,
      active: false,
      showTooltip: false
    };
    _this.ref = /*#__PURE__*/React.createRef();
    _this.refTooltip = /*#__PURE__*/React.createRef();
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setWidth();
      window.addEventListener('resize', this.setWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setWidth);
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this$props3 = this.props,
          onClear = _this$props3.onClear,
          onChange = _this$props3.onChange,
          clearable = _this$props3.clearable;

      if (clearable && onClear) {
        onClear();
      } else {
        onChange({
          target: {
            value: ''
          }
        });
      }

      if ((this.ref || {}).current) this.ref.current.focus();
    }
  }, {
    key: "renderClearableComponent",
    value: function renderClearableComponent() {
      var _this$props4 = this.props,
          clearable = _this$props4.clearable,
          value = _this$props4.value,
          disabled = _this$props4.disabled;
      if (disabled) return null;
      return clearable && value ? /*#__PURE__*/React.createElement(ClearableButton, {
        buttonType: "text",
        "data-testid": "ds-input_clearable-btn",
        disabled: disabled,
        icon: /*#__PURE__*/React.createElement(CloseCircle, null),
        onClick: this.handleClear
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          role = _this$props5.role,
          id = _this$props5.id,
          isShowElipsisActive = _this$props5.isShowElipsisActive,
          autoFocus = _this$props5.autoFocus,
          className = _this$props5.className,
          name = _this$props5.name,
          innerRef = _this$props5.innerRef,
          maxLength = _this$props5.maxLength,
          minLength = _this$props5.minLength,
          placeholder = _this$props5.placeholder,
          leftComponent = _this$props5.leftComponent,
          rightComponent = _this$props5.rightComponent,
          disableTooltip = _this$props5.disableTooltip,
          readOnly = _this$props5.readOnly,
          disabled = _this$props5.disabled,
          value = _this$props5.value,
          onClick = _this$props5.onClick,
          onChange = _this$props5.onChange,
          onKeyDown = _this$props5.onKeyDown,
          onKeyUp = _this$props5.onKeyUp,
          onFocus = _this$props5.onFocus,
          onBlur = _this$props5.onBlur,
          onPaste = _this$props5.onPaste,
          required = _this$props5.required,
          type = _this$props5.type,
          customInputType = _this$props5.customInputType,
          min = _this$props5.min,
          max = _this$props5.max,
          clearable = _this$props5.clearable,
          onMouseLeave = _this$props5.onMouseLeave,
          onMouseOut = _this$props5.onMouseOut,
          style = _this$props5.style,
          containerProps = _this$props5.containerProps,
          tabIndex = _this$props5.tabIndex,
          hasError = _this$props5.hasError,
          rest = _objectWithoutProperties(_this$props5, ["role", "id", "isShowElipsisActive", "autoFocus", "className", "name", "innerRef", "maxLength", "minLength", "placeholder", "leftComponent", "rightComponent", "disableTooltip", "readOnly", "disabled", "value", "onClick", "onChange", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "onPaste", "required", "type", "customInputType", "min", "max", "clearable", "onMouseLeave", "onMouseOut", "style", "containerProps", "tabIndex", "hasError"]);

      var _this$state = this.state,
          width = _this$state.width,
          active = _this$state.active,
          showTooltip = _this$state.showTooltip;
      var rightComponents = [this.renderClearableComponent(), rightComponent].filter(getValidComponents);
      var leftComponents = [leftComponent].filter(getValidComponents);

      var inputProps = _objectSpread({
        'aria-label': rest['aria-label'],
        'aria-placeholder': placeholder,
        'aria-required': required,
        'aria-multiline': false,
        'aria-autocomplete': 'none',
        'data-testid': rest['data-testid'],
        role: role,
        id: id,
        ref: this.ref,
        className: className,
        autoFocus: autoFocus,
        disabled: disabled || readOnly,
        innerRef: innerRef,
        maxLength: maxLength,
        minLength: minLength,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onPaste: onPaste,
        onMouseLeave: onMouseLeave,
        disableTooltip: disableTooltip,
        onMouseOut: onMouseOut,
        placeholder: placeholder,
        required: required,
        type: type,
        value: value,
        min: min,
        max: max,
        style: style,
        tabIndex: tabIndex
      }, containerProps);

      var InputComponent = /*#__PURE__*/React.createElement(WrapperForTooltipInput, {
        ref: this.refTooltip,
        style: {
          width: '100%'
        }
      }, !customInputType ? /*#__PURE__*/React.createElement(Input, _extends({}, omit(inputProps, ['disableTooltip']), {
        autoComplete: "off",
        clearable: "".concat(clearable),
        onChange: this.handleOnChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus // using mouseOver instead of mouseEnter (doesn't trigger on disabled inputs)
        // https://github.com/facebook/react/issues/4251
        ,
        onMouseOver: this.handleMouseEnter // using mouseOut instead of mouseLeave (doesn't trigger on disabled inputs)
        // https://github.com/facebook/react/issues/4251
        ,
        onMouseOut: this.handleMouseLeave,
        value: value
      })) : /*#__PURE__*/React.createElement(InputCustomWrapper, _extends({
        className: className
      }, containerProps, {
        clearable: clearable,
        value: value
      }), customInputType(_objectSpread({}, inputProps))));

      if (isShowElipsisActive) {
        InputComponent = /*#__PURE__*/React.createElement(DSTooltip, {
          isOpen: !disableTooltip && showEllipsis(width, value) && !active && showTooltip && width,
          title: String(value),
          zIndex: 11,
          triggerComponent: /*#__PURE__*/React.createElement(WrapperForTooltipInput, {
            style: {
              width: '100%'
            }
          }, InputComponent)
        });
      }

      var renderInput = rightComponents.length || leftComponents.length || clearable ? /*#__PURE__*/React.createElement(InputAddonWrapper, _extends({
        className: className,
        leftComponents: leftComponents,
        rightComponents: rightComponents,
        hasError: hasError
      }, containerProps), InputComponent) : InputComponent;
      return renderInput;
    }
  }]);

  return InputImpl;
}(Component);

InputImpl.defaultProps = {
  onBlur: noop,
  onFocus: noop
};
InputImpl.propTypes = {
  className: PropTypes.string,
  customInputType: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isShowElipsisActive: PropTypes.bool,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOut: PropTypes.func,
  onPaste: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  role: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  leftComponent: PropTypes.element,
  rightComponent: PropTypes.element,
  disableTooltip: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  type: PropTypes.string,
  clearable: PropTypes.bool,
  containerProps: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line jsdoc/require-returns

  /**
   * Should be of type string if using ellipsis tooltip [isShowElipsisActive] prop
   *
   * @param props
   * @param propName
   * @param componentName
   */
  // eslint-disable-next-line consistent-return
  value: function value(props, propName, componentName) {
    // eslint-disable-line consistent-return
    if (!!props.isShowElipsisActive && typeof props[propName] !== 'string') {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(props[propName]), "` supplied to") + " `".concat(componentName, "`. Prop `value` should be of type `string` if prop `isShowElipsisActive` is set to `true`.") + ' Either set `isShowElipsisActive` to `false`, or properly format your `value` prop to `string`.');
    }
  }
};

export default InputImpl;
//# sourceMappingURL=InputImpl.js.map
